//* Dependencies
import React from "react";

//* Contexts
import AppContextProvider from "./src/shared/contexts/AppContext/AppContext";


export const wrapRootElement = ({ element }) => {
    return <AppContextProvider>{element}</AppContextProvider>
}